<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
// eslint-disable-next-line
import zhCN from 'ant-design-vue/lib/locale/zh_CN';
import { deviceEnquire } from '@/utils/device'
import { ConfigProvider } from 'ant-design-vue'

export default {
  name: 'app',
  components: {
    'a-config-provider': ConfigProvider
  },
  data () {
    return {
      zhCN
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  mounted () {
    if (this._isMobile()) {
      this.$router.replace('/index')
    } else {
      deviceEnquire(deviceType =>
        this.$store.commit('app/SET_DEVICE', deviceType)
      )
    }
    // deviceEnquire(deviceType =>
    //   this.$store.commit('app/SET_DEVICE', deviceType)
    // )
  }
}
</script>
